module.exports = __webpack_public_path__ + "static/media/icon facebook footer-01.5343373a.svg";